<template>
    <card>
		<div>
			<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить хелпдеск" />
		</div>
		<div>
			<el-table :data="ApiData" style="width: 100%;">
				<el-table-column
					label="ID"
					property="id"
					width="80"
					sortable
			>
			</el-table-column>
			<el-table-column 
					min-width="180"
					label="Название хелпдеска"
					property="name"
					sortable
			>
				<template v-slot="scope">		
					<base-input
						v-model="scope.row.name"
						autocomplete="off"
						type="text"
					>
					</base-input>
				</template>
			</el-table-column>
			
			<el-table-column
					width="300"
					label="Действие"
					align="right"                    	
			>
				<template v-slot="scope">		
						<el-tooltip content="Сохранить название хэлпдеска" placement="top">
							<el-button class="no-border my-0" >
								<button class="ml-3 btn btn-icon btn-simple btn-success" @click="UpdateRow(scope.row)">
									<i class="tim-icons icon-book-bookmark"></i>
								</button>											
							</el-button>
						</el-tooltip>	
						<el-tooltip content="Добавить сотрудников" placement="top">
							<el-button class="no-border my-0">
								<button class="ml-3 btn btn-icon btn-simple btn-success" @click="GoEdit(scope.row)">
									<i class="tim-icons icon-pencil"></i>
								</button>											
							</el-button>
						</el-tooltip>		
						<el-tooltip content="Удалить" placement="top">
							<el-button class="no-border my-0">
								<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
									<i class="tim-icons icon-trash-simple"></i>
								</button>											
							</el-button>
						</el-tooltip>		
					</template>
			</el-table-column>
			
			</el-table>
		</div>
    </card>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import Pagination from 'src/our_components/RePagination';

export default {
	name: 'helpdesk-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// ReFilterBtn,
        // ReFilter,
        ReFormPrinter,
        // Pagination,
	},
	data() {
		return {
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('HELPDESK.GET',{flt:{'list':'true','c2p':100}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFormConfig() {
			this.$GVO.ApiCall('HELPDESK.GET_FORM_MODEL',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'HELPDESK.INS',apiParam:{iData:[]}};
        },
		SuccessGo(evt,dopParam){
	        this.masAllFormParams = this.currentFormConfig();
			this.getApiData();
		},
		DeleteRow(row){
			if(row.id != null){
				this.$GVO.ApiCall('HELPDESK.DEL',{ flt:{id: row.id}}) 
					.then((objApi) => {
						if(objApi.success === true){
							this.getApiData();
						}else{
							alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		GoEdit(row){
			if(row.id != null){
				this.$router.push({path: this.$GVO.str_replace('/helpdesk','/helpdeskstaff',location.pathname)+'/'+row.id});
			}
		},
		UpdateRow(row){
			// console.log('UpdateMenu. This is row id '+ row.id + ' and menu row name is ' + row.name); 
			
				if(row.id != null){
					this.$GVO.ApiCall('HELPDESK.UPD',{ flt:{id: row.id},uData:{
						'name': row.name,
						// 'act': row.act,
						}}).then((objApi) => {
							//console.log(objApi);
							if(objApi.success === true){
								this.getApiData();
								// this.openFullScreen1();
							}else{
								alert('Не сохранилось');
							}
						}).catch(errorObjApi => {console.error(errorObjApi);});
				}

			// 	if(this.$GVO.my_profile.code == 10420){}else {
			// 	this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на создание и редактирование названия. От сотрудника 10420</p>')
			// }

			// if(this.$GVO.my_profile.code == 11955 || this.$GVO.my_profile.code == 8136 || this.$GVO.my_profile.code == 8137 || this.$GVO.my_profile.code == 10420){
				
			// } else {
			// 	// this.$GVO.showAlert('Доступ запрещён','<p>У Вас нет прав на создание и редактирование меню.</p>')
			// 	alert('У Вас нет прав на редактирование меню');
			// }
		}, 
	},		
	mounted() {
		this.getApiData();
	}
};
</script>
<style>
</style>
